import { cloneDeep } from 'lodash-es';

/**
 * Clones a screen object and removes all screenIndex properties.
 * This is used to prepare screen objects for serialization or API calls
 * where runtime-only properties should be excluded.
 */
export function removeScreenIndex(
  screen: UcScreen | null | undefined
): UcScreen | null {
  if (!screen) return null;

  const cloned = cloneDeep(screen);

  // Delete screenIndex from the cloned object
  delete cloned.screenIndex;

  // Delete screenIndex from bank items if they exist
  if (cloned.bank) {
    cloned.bank.forEach((b: any) => delete b.screenIndex);
  }

  return cloned;
}

export function removeScreenIndexFromYaml(yaml: string): string {
  if (typeof yaml !== 'string') return '';
  // Remove any line whose key is screenIndex (indentation + key + value)
  return yaml.replace(/^[ \t-]*screenIndex:[^\n]*\r?\n?/gm, '');
}
